module.exports = __webpack_public_path__ + "img/img6.cf8f4a89.png";